/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Inherited_Prefix_TenantInputs */

const en_settings_inherited_prefix_tenant = /** @type {(inputs: Settings_Inherited_Prefix_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This setting is set globally for the current `)
};

const de_settings_inherited_prefix_tenant = /** @type {(inputs: Settings_Inherited_Prefix_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Einstellung ist global für den aktuellen `)
};

/**
* | output |
* | --- |
* | "This setting is set globally for the current" |
*
* @param {Settings_Inherited_Prefix_TenantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_inherited_prefix_tenant = /** @type {((inputs?: Settings_Inherited_Prefix_TenantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Inherited_Prefix_TenantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_inherited_prefix_tenant(inputs)
	return de_settings_inherited_prefix_tenant(inputs)
});